import(/* webpackMode: "eager", webpackExports: ["CalendarClient"] */ "/private/tmp/rf-gpw-ebi-recovery-build-20261012/src/app/narzedzia-inwestora/kalendarz-wynikow-gpw/CalendarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccountNav"] */ "/private/tmp/rf-gpw-ebi-recovery-build-20261012/src/components/account/AccountNav.tsx");
;
import(/* webpackMode: "eager" */ "/Users/bartoszkowalczyk/Documents/New project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/bartoszkowalczyk/Documents/New project/node_modules/next/dist/client/image-component.js");
